// Frontend API Configuration
const config = {
  baseURL: process.env.REACT_APP_API_URL || '/portal/api',
  timeout: process.env.REACT_APP_API_TIMEOUT || 10000,
  headers: {
    'Content-Type': 'application/json',
    'Accept': 'application/json'
  }
};


// Function to get dynamic configuration from server
export const getServerConfig = async () => {
  try {
    const response = await fetch(`${config.baseURL}/config/frontend`);
    const data = await response.json();
    if (data.success) {
      return data.config;
    }
    throw new Error('Failed to fetch server configuration');
  } catch (error) {
    console.error('Error fetching server config:', error);
    // Fallback to default config
    return {
      apiUrl: config.baseURL,
      apiTimeout: config.timeout,
      environment: 'development',
      frontendUrl: 'http://localhost:3000'
    };
  }
};

export default config;
